export default __webpack_public_path__ + "static/media/javascript.f84ec710.svg";